import { IconX } from "../icons/IconsMedico";
import "./Modal.css";

const Modal = ({ title, onClose, children }) => (
    <div className="modal-backdrop" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal__header">
                <h3>{title}</h3>
                <button className="modal__close" onClick={onClose}>
                    <IconX />
                </button>
            </div>
            <div className="modal__body">{children}</div>
        </div>
    </div>
);

export default Modal;
